import { useValuationTranslation } from '@/pages/CompanyReport/components/Valuation/hooks/useValuationTranslation';

export const useMetricFullLabel = () => {
  const t = useValuationTranslation();
  return (metric: 'PB' | 'PS' | 'Forward PS' | 'PE' | 'Forward PE' | 'n/a') => {
    switch (metric) {
      case 'PB':
        return t('pbLabel');
      case 'PS':
      case 'Forward PS':
        return t('psLabel');
      case 'PE':
        return t('peLabel');
      case 'Forward PE':
        return t('keyMetric.forwardPE');
      case 'n/a':
        return t('notAvailable');
    }
  };
};
